module.exports = __webpack_public_path__ + "static/img/1.bac8200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.jpg
// module id = Erzt
// module chunks = 1